import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Divider,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import useMenuStore from "../../stores/MenuStore";

// Paths
import pathRoutes from "../../routes/pathRoutes";

// Iconos
import IconButton from "@mui/material/IconButton";
import { useDynamicSidebar } from "../../context/DynamicSidebarContext";
import SampleInformation from "../SampleInformation";
import Icon from "../Icon";
import MButton from "../MButton";

const selectPath = {
  [pathRoutes.ADMIN_USUARIOS]: 1,
  [pathRoutes.ADMIN_MASTER_TABLES]: 2,
  [pathRoutes.ADMIN_FONDOS]: 3,
  [pathRoutes.ADMIN_INCERTIDUMBRES]: 4,
  [pathRoutes.ADMIN_CALIBRACIONES]: 5,
  [pathRoutes.ADMIN_INFORMES]: 6,
  [pathRoutes.ADMIN_TRANSIT]: 7,
};

const pathSections = {
  portal: "samples",
  admin: "admin",
};

const DynamicSidebar: React.FC = () => {
  const currentPath = window.location.pathname;
  const { isAdminMode, isDrawerOpen, setIsDrawerOpen } = useMenuStore();
  const [selectedItem, setSelectedItem] = useState<number | null>(null);
  const [menu, setMenu] = useState<string>("");
  const [menuActive, setMenuActive] = useState<string>("samples");
  const navigate = useNavigate();

  const { sidebar } = useDynamicSidebar();

  useEffect(() => {
    setMenuActive(pathSections[currentPath.split("/")[1]]);
    setSelectedItem(selectPath[currentPath] || -1);
  }, [currentPath, isAdminMode]);

  useEffect(() => {
    if (typeof sidebar?.option !== "undefined") {
      setMenu(sidebar.option);
    } else {
      setMenu("menu");
    }
  }, [sidebar]);

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  const handleMenuAdmin = () => {
    setMenu("menu");
    setMenuActive("admin");
  };

  const adminMenuItems = [
    {
      text: "Usuarios",
      onClick: () => {
        navigate(pathRoutes.ADMIN_USUARIOS);
        setSelectedItem(selectPath[pathRoutes.ADMIN_USUARIOS]);
      },
    },
    {
      text: "Tablas maestras",
      onClick: () => {
        navigate(pathRoutes.ADMIN_MASTER_TABLES);
        setSelectedItem(selectPath[pathRoutes.ADMIN_MASTER_TABLES]);
      },
    },
    {
      text: "Fondos",
      onClick: () => {
        navigate(pathRoutes.ADMIN_FONDOS);
        setSelectedItem(selectPath[pathRoutes.ADMIN_FONDOS]);
      },
    },
    {
      text: "Incertidumbres",
      onClick: () => {
        navigate(pathRoutes.ADMIN_INCERTIDUMBRES);
        setSelectedItem(selectPath[pathRoutes.ADMIN_INCERTIDUMBRES]);
      },
    },
    {
      text: "Calibraciones",
      onClick: () => {
        navigate(pathRoutes.ADMIN_CALIBRACIONES);
        setSelectedItem(selectPath[pathRoutes.ADMIN_CALIBRACIONES]);
      },
    },
    {
      text: "Informes",
      onClick: () => {
        navigate(pathRoutes.ADMIN_INFORMES);
        setSelectedItem(selectPath[pathRoutes.ADMIN_INFORMES]);
      },
    },
    {
      text: "Dosis de tránsito",
      onClick: () => {
        navigate(pathRoutes.ADMIN_TRANSIT);
        setSelectedItem(selectPath[pathRoutes.ADMIN_TRANSIT]);
      },
    },
  ];

  const menuItems = menuActive === pathSections.admin ? adminMenuItems : [];

  return (
    <>
      <Drawer
        variant="persistent"
        anchor="left"
        open={isDrawerOpen}
        sx={{
          width: 0,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: 240,
            boxSizing: "border-box",
            marginTop: 3,
          },
        }}
      >
        <Box sx={{ textAlign: "center", padding: "1.5rem 0 0 0" }}>
          <IconButton onClick={handleDrawerClose} sx={{ padding: 0 }}>
            <img
              src="/images/logo_ma.png"
              alt="Logo Medidas Ambientales"
              style={{
                maxWidth: "100%",
                height: "auto",
              }}
            />
          </IconButton>
          <Divider
            sx={{
              maxWidth: "100%",
              margin: "1rem 0",
            }}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            margin: "1rem 2rem",
          }}
        >
          {menu !== "info" && (
            <>
              <MButton
                variant={menuActive === "samples" ? "contained" : "outlined"}
                color={menuActive === "samples" ? "primary" : "secondary"}
                text="Muestras"
                sx={{ marginBottom: "1rem" }}
                onClick={() => {
                  navigate(pathRoutes.PORTAL_SAMPLES);
                  setMenuActive("samples");
                }}
              />
              <MButton
                variant={menuActive === "admin" ? "contained" : "outlined"}
                color={menuActive === "admin" ? "primary" : "secondary"}
                text="Administración"
                onClick={handleMenuAdmin}
              />
            </>
          )}
          {menu === "info" && sidebar && (
            //Back buttontea
            <MButton
              variant="outlined"
              color="secondary"
              text="Volver"
              onClick={() => navigate(pathRoutes.PORTAL_SAMPLES)}
              sx={{ marginBottom: "1rem" }}
              startIcon={<Icon name="return" />}
            />
          )}
        </Box>
        {menu === "menu" && (
          <List className="MenuSidebar">
            {menuItems.map((item, index) => (
              <React.Fragment key={index}>
                <ListItemButton
                  onClick={item.onClick}
                  selected={selectedItem === index + 1}
                  sx={{
                    "&.Mui-selected": {
                      backgroundColor: "#D6F0D6",
                      "&:hover": {
                        backgroundColor: "lightblue",
                      },
                    },
                    "&:hover": {
                      backgroundColor: "lightblue",
                    },
                  }}
                >
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </React.Fragment>
            ))}
          </List>
        )}
        {menu === "info" && sidebar && (
          <SampleInformation sample={sidebar?.menu} />
        )}
      </Drawer>
    </>
  );
};

export default DynamicSidebar;
